// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__20Fe3","summary":"CartItem_summary__L5ETV","price":"CartItem_price__vZluN","amount":"CartItem_amount__32F-p","actions":"CartItem_actions__2I9j4"};